<div class="wrapper" *ngIf="firstLoading.status && firstLoading.errorMessage">
  <div class="error">
    <div class="error__icon"></div>
    <p class="error__text">{{'Record you are accessing is either not accessible or do not exist. Please contact you administrator if you believe there should be information displayed on this page.' | translate}}</p>
  </div>
</div>
<ng-content *ngIf="!firstLoading.status"></ng-content>
